import React from "react";
import { Field } from "react-final-form";
import { fieldErrorMessage, textarea } from "./formComponents.css.js";
import { formRow } from "../../styles/common.css.js";

interface Props {
    name: string;
    label: string;
    validator: (v: string) => string | undefined;
}

const TextAreaField: React.FC<Props> = ({ name, label, validator }) => (
    <Field
        name={name}
        render={({ input, meta, rest }) => (
            <div className={formRow}>
                <label htmlFor={`${name}-input`}>{label}</label>
                <textarea
                    id={`${name}-input`}
                    className={textarea}
                    {...input}
                    {...rest}
                />
                {meta.error && meta.touched && (
                    <span className={fieldErrorMessage}>{meta.error}</span>
                )}
            </div>
        )}
        validate={validator}
    />
);

export default TextAreaField;
